(function () {
  'use strict';

  angular
    .module('app.searchfinder', [])

    /* @ngInject */
    .factory('searchFinderService', ["$http", "$q", function ($http, $q) {
      var canceler = $q.defer(),
        ctrl;

      return {
        setCtrl: function (value) {
          ctrl = value;
        },
        getCtrl: function () {
          return ctrl;
        },
        get: function (str, page, nbPerPage, prices, categories, facets, brands, reviews, types) {
          canceler.resolve('cancel');
          canceler = $q.defer();

          var filters = [];
          _.each(categories, function (category) {
            filters.push({
              FieldName: 'IDCatalogueTheme',
              FieldValue: String(category.IDCategory)
            });
          });

          return $http({
            url: '/Search/Query',
            method: 'POST',
            headers: {
              'Content-type': 'application/json',
              'X-Requested-With': 'jsonHttpRequest'
            },
            data: {
              QueryFullText: str,
              NbFrom: (page - 1) * nbPerPage,
              NbSize: nbPerPage,
              FiltersSelected: filters,
              FacetsSelected: facets,
              BrandsSelected: brands,
              ReviewsSelected: reviews,
              ProductTypesSelected: types,
              PriceRangeSelected: prices,
              withCatalogs: true,
              withFacets: false,
              Sort: null
            },
            timeout: canceler.promise
          })
            .then(function (response) {
              return response.data;
            })
            .catch(function (error) {
              throw error;
            });
        }
      };
    }])

    /* @ngInject */
    .factory('SearchFinderApi', ["$timeout", "searchFinderService", "AppService", function ($timeout, searchFinderService, AppService) {
      var api = function () {
        this.ctrl = null;
        this.items = [];
        this.advices = [];
        this.filters = {};
        this.total = 0;
        this.busy = false;
        this.page = 0;
        this.search = '';
        this.PriceRange = {};
        this.CategoriesSelected = [];
        this.BrandsSelected = [];
        this.FacetsSelected = [];
        this.ReviewsSelected = [];
        this.ProductTypesSelected = [];
        this.getSearch = function () {
          return this.search;
        };
      };

      api.prototype.nextPage = function () {
        var _this = this;
        if ((!this.update && this.busy) || (!this.update && this.page === this.maxPage)) return;

        this.busy = true;

        var facets = _.filter(this.FacetsSelected, function (item) {
          return item.Values.length;
        });

        searchFinderService.get(this.search, ++this.page, this.nbPerPage, this.PriceRange, this.CategoriesSelected, facets, this.BrandsSelected, this.ReviewsSelected, this.ProductTypesSelected)
          .then(function (data) {
            if (_this.update) {
              _this.items = [];
              _this.advices = [];
            }
            $timeout(function () {
              _this.items = _this.items.concat(_.filter(data.products, { KeyWebAspect: 'Default' }));
              _this.advices = _this.ctrl.device.xxs ? [] : _this.advices.concat(_.filter(data.products, { KeyWebAspect: 'Advice' }));

              _.each(_this.items, function (item) {
                item.isWithoutPrice = _.filter(item.Themes, { 'KeyTheme': 'WithOutPrice' }).length > 0;
              });

              if (!_this.FacetsSelected.length) {
                _.each(data.facets, function (item) {
                  _this.FacetsSelected.push({ Id: item.Id, Name: item.Name, Key: item.Key, Values: [] });
                });
              }
              _this.setDataFilters(data)
                .then(function (filters) {
                  _this.filters = filters;
                  _this.setSelectedFilters();
                });

              _this.total = data.total;
              _this.maxPage = Math.ceil(_this.total / _this.nbPerPage) ? Math.ceil(_this.total / _this.nbPerPage) : 1;
              _this.busy = false;
              _this.update = false;
              _this.searchCtrl.searching = false;


              _this.ctrl.updateSearchApi();
            });
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      api.prototype.setSelectedFilters = function () {
        var _this = this;

        _this.filters.categories.open = false;
        _.each(_this.filters.categories.items, function (item) {
          item.Selected = typeof _.find(_this.CategoriesSelected, { IDCategory: item.IDCategory }) != 'undefined';
          if (item.Selected) _this.filters.categories.open = true;
        });

        _this.filters.brands.open = false;
        _.each(_this.filters.brands.items, function (item) {
          item.selected = typeof _.find(_this.BrandsSelected, { Id: item.Id }) != 'undefined';
          if (item.selected) _this.filters.brands.open = true;
        });

        _.each(_this.filters.facets, function (facet) {
          facet.open = false;
          var sel = _.find(_this.FacetsSelected, { Id: facet.Id });
          _.each(facet.Values, function (itemValue) {
            itemValue.selected = _.includes(sel.Values, itemValue.Value);
            if (itemValue.selected) facet.open = true;
            // itemValue.selected = facet.isColor ? !itemValue.selected : itemValue.selected;
          });
        });

        _this.filters.reviews.open = false;
        _.each(_this.filters.reviews.items, function (item) {
          item.selected = _.includes(_this.ReviewsSelected, String(item.Name));
          if (item.selected) _this.filters.reviews.open = true;
        });

        _this.filters.types.open = false;
        _.each(_this.filters.types.items, function (item) {
          item.selected = typeof _.find(_this.ProductTypesSelected, { Id: item.Id }) != 'undefined';
          if (item.selected) _this.filters.types.open = true;
        });

      };

      api.prototype.selectPrices = function (min, max) {
        var _this = this;

        _this.PriceRange = {};
        _this.filters.prices.selectedMinPrice = min >= _this.filters.prices.minPrice ? min : _this.filters.prices.minPrice;
        _this.filters.prices.selectedMaxPrice = max <= _this.filters.prices.maxPrice ? max : _this.filters.prices.maxPrice;

        if (min !== _this.filters.prices.minPrice || max !== _this.filters.prices.maxPrice) {
          _this.PriceRange = {
            Gte: min,
            Lte: max
          };
        }
      };

      api.prototype.setDataFilters = function (data) {
        var _this = this;
        return AppService.getTranslate()
          .then(function (translate) {
            var filters = {};

            filters.prices = {
              open: false,
              minPrice: data.prices.minPrice,
              maxPrice: data.prices.maxPrice,
              options: {},
              selectedMinPrice: null,
              selectedMaxPrice: null
            };
            filters.pricesActive = false;
            if (filters.prices.minPrice !== filters.prices.maxPrice) {
              filters.prices.minPrice = Math.floor(filters.prices.minPrice / 10) * 10;
              filters.prices.maxPrice = Math.ceil(filters.prices.maxPrice / 10) * 10;

              if (typeof _this.PriceRange.Gte === 'undefined') {
                filters.prices.selectedMinPrice = filters.prices.minPrice;
                filters.prices.selectedMaxPrice = filters.prices.maxPrice;
              } else {
                filters.prices.selectedMinPrice = _this.PriceRange.Gte;
                filters.prices.selectedMaxPrice = _this.PriceRange.Lte;
              }

              if (filters.prices.selectedMinPrice < filters.prices.minPrice) {
                filters.prices.selectedMinPrice = filters.prices.minPrice;
              }
              if (filters.prices.selectedMaxPrice > filters.prices.maxPrice) {
                filters.prices.selectedMaxPrice = filters.prices.maxPrice;
              }

              var startMin,
                startMax;
              filters.prices.options = {
                floor: filters.prices.minPrice,
                ceil: filters.prices.maxPrice,
                step: 10,
                minRange: 10,
                translate: function (value) {
                  return value + ' €';
                },
                onStart: function () {
                  startMin = filters.prices.selectedMinPrice;
                  startMax = filters.prices.selectedMaxPrice;
                },
                // eslint-disable-next-line
                onEnd: function (sliderId, min, max) {
                  if (min !== startMin || max !== startMax) {
                    _this.selectPrices(min, max);
                    _this.update = true;
                    _this.page = 0;
                    _this.nextPage();
                  }
                  startMin = null;
                  startMax = null;
                }
              };
              filters.pricesActive = true;
            }

            filters.categories = {
              open: false,
              items: data.categories
            };

            filters.brands = {
              open: false,
              items: data.brands
            };

            filters.facets = data.facets;
            _.each(filters.facets, function (facet) {
              facet.open = false;
              _.each(facet.Values, function (itemValue) {
                itemValue.checkValue = itemValue.Value;
                itemValue.selectedValue = itemValue.Value;
                itemValue.ref = _.camelCase(itemValue.Value);
                itemValue.selected = false;
                if (facet.Name.indexOf('Couleur') !== -1) {
                  facet.isColor = true;
                  itemValue.colorImg = '/img/colors/21x21/' + _.kebabCase(itemValue.Value) + '.png';
                }
                if (facet.Type === 'Vrai/Faux') {
                  itemValue.checkValue = parseInt(itemValue.Value) === 0 ? translate.messages.No : translate.messages.Yes;
                  itemValue.selectedValue = parseInt(itemValue.Value) === 0 ? facet.Name + translate.messages.Colon + ' ' + translate.messages.No : facet.Name + translate.messages.Colon + ' ' + translate.messages.Yes;
                  itemValue.ref = _.camelCase(itemValue.checkValue);
                }
              });
            });

            filters.reviews = {
              open: false,
              items: _.filter(data.reviews, function (item) {
                return item.Name > 0;
              })
            };

            filters.types = {
              open: false,
              items: data.types
            };

            return filters;
          })
          .catch(function (response) {
            console.error(response);
          });
      };

      return api;
    }])

    /* @ngInject */
    .component('searchFinder', {
      bindings: {
        device: '<',
        nbPerPage: '<'
      },
      templateUrl: '/Template/Autocomplete/SearchFinder',
      /* @ngInject */
      controller: ["$scope", "$element", "$timeout", "$location", "WindowEventsService", "productsGridService", "searchFinderService", "SearchFinderApi", function ($scope, $element, $timeout, $location, WindowEventsService, productsGridService, searchFinderService, SearchFinderApi) {
        var ctrl = this;

        ctrl.$onInit = function () {
          ctrl.api = new SearchFinderApi();
          ctrl.api.ctrl = ctrl;
          ctrl.api.nbPerPage = ctrl.nbPerPage;
          ctrl.api.searchCtrl = searchFinderService.getCtrl();
          resize();
        };

        ctrl.close = function () {
          clearResults();
        };

        ctrl.loaded = function () {
          $timeout(function () {
            productsGridService.resizeGrid('searchGrid', ctrl.device.size, !ctrl.api.update);
          });
        };

        ctrl.setCategory = function (item) {
          if (item.Selected) {
            ctrl.api.CategoriesSelected.push({ IDCategory: item.IDCategory });
          } else {
            _.pullAllBy(ctrl.api.CategoriesSelected, [{ IDCategory: item.IDCategory }], 'IDCategory');
          }
          ctrl.api.setSelectedFilters();
          updateSearch();
        };

        ctrl.setFacet = function (item, itemValue) {
          var facet = _.find(ctrl.api.FacetsSelected, { Id: item.Id });

          if (item.isColor) {
            itemValue.selected = !itemValue.selected;
          }
          if (itemValue.selected) {
            facet.Values.push(itemValue.Value);
          } else {
            _.pull(facet.Values, itemValue.Value);
          }
          ctrl.api.setSelectedFilters();
          updateSearch();
        };
        ctrl.setBrand = function (item) {
          selectFilter(item, ctrl.api.BrandsSelected, false);
        };
        ctrl.setReview = function (item) {
          selectFilter(item, ctrl.api.ReviewsSelected, true);
        };
        ctrl.setType = function (item) {
          selectFilter(item, ctrl.api.ProductTypesSelected, false);
        };

        ctrl.openItem = function (item) {
          $location.path(item.URL + '/es/' + ctrl.api.searchCtrl.searchStr.split(' ').join('+'));
          clearResults();
          console.log('redirection');
        };

        ctrl.updateSearchApi = function () {
          var $body = $(document.body);
          if (ctrl.api.total > 0) {
            $body.addClass('fixed-search');
            if (ctrl.device.mobile && ctrl.device.isTouch) {
              $body.css('top', '-' + ($('#header').height() - $('.auto-complete-search').height()) + 'px');
              resize();
              setTimeout(resize, 800);
            }
          } else {
            $body.removeClass('fixed-search').removeAttr('style');
          }
        };

        // Events

        $scope.$on('searchClose', function () {
          clearResults();
        });

        $scope.$on('searchUpdate', function () {
          if (ctrl.api.searchCtrl.searchStr === '') {
            clearResults();
            return;
          }
          if (ctrl.api.searchCtrl.searchStr.length < 3) return;
          ctrl.api.PriceRange = {};
          ctrl.api.CategoriesSelected = [];
          ctrl.api.BrandsSelected = [];
          ctrl.api.FacetsSelected = [];
          ctrl.api.ReviewsSelected = [];
          ctrl.api.ProductTypesSelected = [];
          ctrl.api.search = ctrl.api.searchCtrl.searchStr;
          ctrl.api.searchCtrl.searching = true;
          updateSearch();
          $element.addClass('active');
        });

        $scope.$on('topUpdate', resize);

        WindowEventsService.listen(true, 'resize', resize, 500);

        $scope.$on('$destroy', function () {
          WindowEventsService.listen(false, 'resize', resize);
        });

        // Functions

        function selectFilter(item, target, isReview) {
          if (isReview) {
            if (item.selected) {
              target.push(String(item.Name));
            } else {
              _.pull(target, String(item.Name));
            }
          } else if (item.selected) {
            target.push({ Id: item.Id });
          } else {
            _.pullAllBy(target, [{ Id: item.Id }], 'Id');
          }
          ctrl.api.setSelectedFilters();
          updateSearch();
        }
        function updateSearch() {
          ctrl.api.update = true;
          ctrl.api.page = 0;
          ctrl.api.nextPage();
        }

        function resize() {
          var element = $('#header'),
            // pos = element.offset().top + element.height(),
            pos = element.height(),
            height = 'calc(100vh - ' + pos + 'px)';

          pos = ctrl.device.desktop ? pos - 4 : pos;
          if (ctrl.device.mobile && ctrl.device.isTouch) {
            pos = $('#header').height();
            height = ($(document.body).height() - $('.auto-complete-search').height()) + 'px';
          }
          $element.css({
            top: pos,
            height: height
          });

          $timeout(function () {
            productsGridService.resizeGrid('searchGrid', ctrl.device.size, false);
          });

        }
        function clearResults() {
          ctrl.api.search = '';
          ctrl.api.total = 0;
          ctrl.api.searchCtrl.searchStr = '';
          ctrl.api.searchCtrl.searching = false;
          $element.removeClass('active');
          ctrl.updateSearchApi();
        }

      }]
    })

    /* @ngInject */
    .filter('matchstring', ["$sce", function ($sce) {
      return function (value, str) {
        if (!value) { return false; }
        if (!value.match || !value.replace) { value = value.toString(); }
        var matches, reg;

        var words = str.split(' '),
          tmp;
        _.each(words, function (word) {
          tmp = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          if (tmp.length > 2) {
            reg = new RegExp(tmp, 'ig');
            matches = value.match(reg);
            if (matches) {
              value = value.replace(reg, '##' + matches[0] + '#/#');
            }
          }
        });

        var open = new RegExp('##', 'g'),
          close = new RegExp('#/#', 'g');
        value = value.replace(open, '<span class="match">').replace(close, '</span>');
        return $sce.trustAsHtml(value).valueOf();
      };
    }]);

})();
